export const isGreaterThanDesktopSmall = state => state.browser.greaterThan.desktopSmall;

export const isGreaterThanTablet = state => state.browser.greaterThan.tablet;

export const isGreaterThanMobile = state => state.browser.greaterThan.mobile;



// WEBPACK FOOTER //
// ./src/store/selectors/browser.js